import i18n from '../../i18n';
import { appMonthNameYear } from '@/utils/appDateFormat';
import { parseApiDateOnly } from '@/utils/apiDate';

/**
 * The calendar pay period a payslip covers, e.g. `1-30 Sep 2026` (month name in the app language).
 *
 * A payslip's `payrollDate` is the first day of its pay month, not the day it was paid, so it must
 * never be shown as a "Payment date". Returns '' when the date cannot be read, so callers can fall
 * back to the month label.
 */
export const payPeriodRange = (payrollDate?: string | Date | null): string => {
  const date = parseApiDateOnly(payrollDate ?? null);
  if (!date || Number.isNaN(date.getTime())) return '';
  const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  return i18n.t('payslip.payPeriodRange', {
    start: 1,
    end: lastDay,
    monthYear: appMonthNameYear(date, 'short'),
    defaultValue: '{{start}}-{{end}} {{monthYear}}',
  });
};
